import { useSelector } from 'react-redux'

import { enUS, es, it, pl, pt, nl, de, fr } from 'date-fns/locale'
import { intlFormat } from '@/local/server-data/utils/smartUtils/conversion'

import { selectUserConfiguration } from '@/features/domain/user'

const localeMap: Record<string, Locale> = {
  'en-US': enUS,
  'us-US': enUS,
  'es-ES': es,
  'it-IT': it,
  'pl-PL': pl,
  'pt-PT': pt,
  'nl-NL': nl,
  'de-DE': de,
  'fr-FR': fr,
}

export const useDateFnsLocale = () => {
  const userConfig = useSelector(selectUserConfiguration)
  const localeCode = intlFormat[userConfig.language]
  return localeMap[localeCode]
}
